import Common from '../../Common';

const DID = class extends Common {
	async browse(userId: id) {
		return this.get(`/user/${userId}/did`)
	}
}

export default DID;
